export const TrustedByCompanies = () => {
  return (
    <div className="container-lg flex justify-center">
      <div className="">
        <div className="text-11-16  text-gray-600">
          Trusted by innovative companies
        </div>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-28 md:flex-nowrap ">
          <a
            href="https://writesonic.com"
            target="_blank"
            rel="noreferrer"
            className="shrink-0"
          >
            <img
              src="/assets/customers/writesonic-black.svg"
              alt="Writesonic"
              className="opacity-40 grayscale hover:opacity-100 hover:grayscale-0"
            />
          </a>
          <a
            href="https://retainit.app/"
            target="_blank"
            rel="noreferrer"
            className="shrink-0"
          >
            <img
              src="/assets/customers/retainit.svg"
              alt="Retainit"
              className="h-[16px] opacity-40 grayscale hover:opacity-100 hover:grayscale-0"
            />
          </a>
          <a
            href="https://mem.ai"
            target="_blank"
            rel="noreferrer"
            className="shrink-0"
          >
            <img
              src="/assets/customers/memai.svg"
              alt="Mem.ai"
              className="h-[26px] opacity-40 grayscale hover:opacity-100 hover:grayscale-0"
            />
          </a>

          {/* <a
            href="https://www.reddit.com/"
            target="_blank"
            rel="noreferrer"
            className="shrink-0"
          >
            <img
              src="/assets/customers/reddit.svg"
              alt="Reddit"
              className="h-28 opacity-40 grayscale hover:opacity-100 hover:grayscale-0"
            />
          </a> */}
          <a
            href="https://www.pwc.co.uk/"
            target="_blank"
            rel="noreferrer"
            className="hidden  shrink-0 sm:block"
          >
            <img
              src="/assets/customers/pwc2.png"
              alt="PWC"
              className="h-24 scale-95 opacity-30 grayscale hover:opacity-100 hover:grayscale-0"
            />
          </a>
          <a
            href="https://www.peppertype.ai/"
            target="_blank"
            rel="noreferrer"
            className="hidden shrink-0 homeXs:block "
          >
            <img
              src="/assets/customers/peppertype.svg"
              alt="Peppertype.ai"
              className="opacity-40 grayscale hover:opacity-100 hover:grayscale-0"
            />
          </a>
        </div>
      </div>
    </div>
  );
};
